import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/06_ai_filters.png';

const AiFiltersIndustry = () => {
  return (
    <IndustryPageTemplate
      title="AI Filters"
      subtitle="Smart Enhancements and Transformations"
      desc="Transform your media with smart AI filters and artistic enhancements. Turn ordinary footage into cinematic masterpieces with a single click."
      image={image}
      themeColor="#00bcd4"
      bgGradient="linear-gradient(135deg, rgba(0,188,212,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "AI Style Transfer",
    "desc": "Apply the visual style of famous painters and classic films to your clips."
  },
  {
    "title": "Portrait Enhancer",
    "desc": "Smooth skin, brighten eyes, and perfect lighting on human subjects automatically."
  },
  {
    "title": "One-click Filters",
    "desc": "Access a library of over 500 premium LUTs and dynamic filters."
  },
  {
    "title": "Color Correction",
    "desc": "Auto-balance white levels, exposure, and saturation using machine learning."
  }
]}
    />
  );
};

export default AiFiltersIndustry;
